import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select';
import { Flex, Box, Button } from 'rebass/styled-components'
import { Input } from '@rebass/forms/styled-components'
import styled, { ThemeContext } from 'styled-components'

const FilterOptions = styled(Flex)`
    input:not([type='hidden']) {
        border-color: ${(props) => props.theme.colors.aquaMedium};
        border-radius: 0;
        border-style: solid;
        border-width: 2px;
        font-family: ${(props) => props.theme.fonts.body};
        outline: none;
        padding: 10px;

        transition-duration: 300ms;
        transition-timing-function: ease-out;
        transition-property: border-color;

        will-change: border-color;

        :focus {
            border-color: ${(props) => props.theme.colors.aquaDark};
        }
    }
`

const customSelect = (theme) => ({
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
        ...provided,
        borderBottom: '1px solid ' + theme.colors.greyLight,
        backgroundColor: (isFocused || isSelected) ? theme.colors.aquaDark : theme.colors.white,
        borderColor: (isFocused || isSelected) ? theme.colors.aquaMedium : theme.colors.aquaDark,
        color: (isFocused || isSelected) ? theme.colors.white : theme.colors.black,
        padding: theme.space.sm,
        cursor: 'pointer',
    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        backgroundColor: theme.colors.white,
        borderColor: theme.colors.aquaMedium,
        borderStyle: 'solid',
        borderWidth: '2px',
        display: 'flex',
        padding: '0',
        width: 200,
    }),
})

const Filter = ({ onChange }) => {
    const theme = useContext(ThemeContext);
    const [filters, setFilters] = useState({ search: '', filter: false })
    const field = 'characteristics.year'

    useEffect(() => {
        if ( filters.search !== '' || filters.filter ) {
            onChange(filters)
        }
    }, [filters])

    const onSelectUpdate = (e) => {
        const { value } = e
        let query = {}
        switch (value) {
        case 'pre':
            query = {
                where: [
                    {
                        item: field,
                        operator: '<=',
                        value: 1940,
                    },
                ],
            }
            break;
        case 'post':
            query = {
                where: [
                    {
                        item: field,
                        operator: '>',
                        value: 1940,
                    },
                ],
            }
            break;
        case '1950':
        case '1960':
        case '1970':
        case '1980':
        case '1990':
            query = {
                where: [
                    {
                        item: field,
                        operator: '>=',
                        value: parseInt(value),
                    },
                    {
                        item: field,
                        operator: '<',
                        value: parseInt(value) + 10,
                    },
                ],
            }
            break;
        case 'modern':
            query = {
                where: [
                    {
                        item: field,
                        operator: '>',
                        value: 2000,
                    },
                ],
            }
            break;
        default:
            break;
        }
        if (value) {
            query.order = {
                by: field,
                direction: 'asc',
            }
        }
        setFilters({ ...filters, filter: query })
    }
    const onTextUpdate = (e) => {
        const { value } = e.target
        setFilters({ ...filters, search: value })
    }
    const resetFilter = () => {
        onChange({ search: '', filter: false })
        setFilters({ search: '', filter: false })
    }
    const options = [
        { value: '', label: 'Era' },
        { value: 'pre', label: 'Pre-War' },
        { value: 'post', label: 'Post-War' },
        { value: '1950', label: '1950s' },
        { value: '1960', label: '1960s' },
        { value: '1970', label: '1970s' },
        { value: '1980', label: '1980s' },
        { value: '1990', label: '1990s' },
        { value: 'modern', label: 'Modern' },
    ]

    return (
        <Box sx={{
            position: 'relative',
            zIndex: 2, // Ensures that dropdown filter items render above badges contained in the feed
        }}>
            <FilterOptions
                alignItems="center"
                flexWrap="wrap"
                justifyContent="flex-end"
                pt="sm"
                pb="sm"
                // pl="md"
                // pr="md"
                as="form"
                autocomplete="off"
                data-disabled="false"
                onSubmit={(e) => e.preventDefault()}
                mb='sm'
                mr="xs"
                role="form"
                // aria-label=""
            >
                <Box
                    flexGrow="1"
                    pb="sm"
                    sx={{
                        maxWidth: '300px',
                    }}
                >
                    <Input onChange={(e) => onTextUpdate(e)} sx={{
                        borderWidth: '2px',
                    }} value={filters && filters.search} type="text" placeholder="Filter" />
                </Box>
                <Box
                    flexBasis="200px"
                    flexShrink="0"
                    ml="sm"
                    pb="sm"
                >
                    <Select
                        styles={customSelect(theme)}
                        value={filters.filter && options.find((obj) => obj.value === filters.filter)}
                        options={options}
                        onChange={onSelectUpdate}
                    />
                </Box>
                <Box
                    alignSelf="center"
                    flexBasis="80px"
                    ml="sm"
                    pb="sm"
                >
                    <Button
                        type="reset"
                        variant="primary"
                        sx={{
                            minWidth: '0',
                        }} onClick={resetFilter}>Reset</Button>
                </Box>
            </FilterOptions>
        </Box>
    )
}

export default Filter
